import { lazyLoad } from "../../../../utils/loadable";

export const DealSpotlightEditorPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
);
